<template>
  <div class="profiles-content-wrap">
    <div class="filter-wrap">
      <PBDRangeSelector />
    </div>
    <div class="table">
      <div class="two-cols">
        <div class="cell">
          <ChartCard :title="$t('pbd_profiles_title_char_1')" chart-id="lang-use" />
        </div>
        <div class="cell">
          <ChartCard :title="$t('pbd_profiles_title_char_2')" chart-id="device-use" />
        </div>
      </div>
      <div class="two-cols">
        <div class="cell">
          <ChartCard
            :title="$t('pbd_profiles_title_char_3')"
            :paginate="true"
            type-filter="country"
            chart-id="country-use"
          />
        </div>
        <div class="cell">
          <ChartCard :title="$t('pbd_profiles_title_char_4')" chart-id="time-use" />
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import PBDRangeSelector from './PBDRangeSelector.vue'
import ChartCard from './ChartCard.vue'

export default {
  components: { PBDRangeSelector, ChartCard },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.profiles-content-wrap
  display: flex
  flex-direction: column
  gap: vw(30px)

  .filter-wrap
    width: vw(350px)

.table
  display: flex
  flex-direction: column
  gap: vw(30px)

  .two-cols
    display: flex
    width: 100%
    gap: vw(30px)

    .mobile &
      flex-direction: column

    .cell
      display: flex
      width: 49%

      .mobile &
        width: 100%
</style>
